<script>
import resources from './resources'

export default {
  name: 'gadget-family-kinsfolk',

  mixins: [resources]
}
</script>

<template lang="pug">
    li
      .col-xs-12.col-sm-6.col-md-3.title
        small.grey
          | Nome
          br
        | {{ dependent.name }}
      .col-xs-12.col-sm-6.col-md-1
        small.grey
          | Idade
          br
        | {{ dependent.age }}
      .col-xs-12.col-sm-6.col-md-2
        small.grey
          | Grau
          br
        | {{ dependent.kinship }}
      .col-xs-12.col-sm-6.col-md-4
        small.grey
          | Convênio
          br
        span(v-if="dependent.covenant")
         | {{ dependent.covenant }}
        span(v-if="!dependent.covenant")
         | Não informado
      .col-xs-12.col-md-2.text-center
        router-link.btn.save(:to="{name: 'patient.agendas.search.speciality', query: {dependent_id: dependent.dependent_id}}")
          span.icon 
          |  Agendar
      .clearfix
</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/family/components/kinsfolk/kinsfolk.vue